import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({})
class Contents extends Vue {}
export default toNative(Contents);
